@for (item of [].constructor(2); track item) {
  <ui-skeleton-loader-legacy [theme]="{ height: '1.75rem' }" />
}
